export enum GameStatus {
	UNDEFINED_GAME_COMPLETION_TYPE = '0',
	GAME_NOT_COMPLETED_TYPE = '1',
	FORFEIT_TEAM_ONE_GAME_COMPLETED_TYPE = '2',
	RETIREMENT_TEAM_ONE_GAME_COMPLETED_TYPE = '3',
	WITHDRAWAL_TEAM_ONE_GAME_COMPLETED_TYPE = '4',
	PLAYED_COMPLETED_TYPE = '5',
	CANCELED_GAME_COMPLETED_TYPE = '6',
	FORFEIT_TEAM_TWO_GAME_COMPLETED_TYPE = '7',
	RETIREMENT_TEAM_TWO_GAME_COMPLETED_TYPE = '8',
	WITHDRAWAL_TEAM_TWO_GAME_COMPLETED_TYPE = '9',
	DID_NOT_PLAYED_COMPLETED_TYPE = '10'
}
